export default {
  name: "services",
  components: {},
  props: [],
  data() {
    return {
      services: [
        {
          smallHeader: "Wireframing, Mockups, Designs",
          header: "UX/UI Design",
          imageComponent: "app-ux-ui-design-image",
          text:
            "We design your product starting with the wireframes. We iterate on these and turn them into a beautiful clickable prototype."
        },
        {
          smallHeader: "Architecture Design, Project Management",
          header: "Architecture",
          imageComponent: "app-consulting-image",
          text:
            "From the requirements collected in the wireframing and design process, we develop a technical architecture that is scalable, reliable and maintainable."
        },
        {
          smallHeader: "TypeScript, VueJS, PWA",
          header: "Front-End Development",
          imageComponent: "app-front-end-development-image",
          text:
            "We take the designs and turn them into a responsive and interactive PWA that gives users a native-like experience with the benefits of a single codebase."
        },
        {
          smallHeader: "TypeScript, Express, Loopback",
          header: "Back-End Development",
          imageComponent: "app-back-end-development-image",
          text:
            "We build a cost-effective serverless backend that scales to your customer's needs."
        },
        {
          smallHeader: "Automated Tests",
          header: "Testing and QA",
          imageComponent: "app-testing-and-qa-image",
          text:
            "We believe in Test Driven Development. It saves time, money and frustration. All of our code is delivered with automated test suites including automated browser tests."
        },
        {
          smallHeader: "Continuous Integration, Delivery, Deployment",
          header: "Deployment",
          imageComponent: "app-full-deployment-image",
          text:
            "The test suites that we build allow us to continuously deliver updates to your customers with confidence"
        }
      ]
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};
